import MyUsersIcon from '@mui/icons-material/GroupsOutlined';
import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import { RootState } from '@/redux/store';
import MyUsersSection from '@/sections/MyUsers';

const MyUsers = () => {
  usePageTitle('Mis usuarios');

  const { profile } = useSelector((state: RootState) => state.parcel);
  const role = profile.data?.configuration.role;
  const navigate = useNavigate();

  useEffect(() => {
    if (role !== 'master') {
      navigate('/statistics');
    }
  }, []);

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mis usuarios" mt={5}>
        <MyUsersIcon fontSize="large" />
      </SectionTitle>
      <MyUsersSection />
    </Container>
  );
};

export default MyUsers;
